import { Box } from '@mui/material';
import DateFormatter from '@apigrowfinance/pbolt-date-formatter';
import { RiTimeLine } from 'react-icons/ri';

import { getMinutesBetweenDates } from '@utils/dateUtil';

export type HistoryDatesBlockProps = {
    startTime: string;
    endTime: string;
};

const HistoryDatesBlock = ({ startTime, endTime }: HistoryDatesBlockProps) => {
    if (!startTime && !endTime) return null;
    let mins = 0;
    const style = { fontSize: '20px', color: 'grey.300', paddingRight: '6px' };
    if (endTime) {
        mins = getMinutesBetweenDates(startTime, endTime);
    }

    return (
        <Box
            data-testid="history-dates-block"
            component="span"
            sx={{
                display: 'inline-flex',
                alignItems: 'center',
                whiteSpace: 'pre-wrap',
                mt: '4px',
                ml: 9,
            }}>
            <RiTimeLine style={style} />
            <DateFormatter date={startTime} format="time" />
            {' > '}
            {endTime ? (
                <>
                    <DateFormatter date={endTime} format="time" />
                    {' • '}
                    {mins} {mins === 1 ? 'min' : 'mins'}
                </>
            ) : (
                'session abandoned.'
            )}
        </Box>
    );
};

export default HistoryDatesBlock;
